module.exports = new __parcel__URL__("error-home.c313e3d4.svg").toString();